export default __webpack_public_path__ + "static/media/signup-icon-patient-inactive.f3926e41.svg";